export default "__VITE_ASSET__BKSGEMUs__"